import { useTranslation } from "react-i18next";
import { Box, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";

import { useAlerts, useInsights } from "@core/apis/PropAI";

import { AlertsTable, InsightsSection } from "../../../../components/Insights";

const InsightsPage = () => {
  const { t } = useTranslation(["propai_insights"]);
  const { substationId, organizationId } = Route.useParams();

  const { alerts, isLoading: alertsLoading } = useAlerts(substationId, organizationId);
  const { goodInsights, badInsights, isLoading: insightsLoading } = useInsights(substationId);

  const isLoading = alertsLoading || insightsLoading;
  const hasAlerts = alerts.length > 0;
  const hasInsights = goodInsights.length > 0 || badInsights.length > 0;
  const isEmpty = !isLoading && !hasAlerts && !hasInsights;

  if (isLoading) {
    return (
      <Box p={3} display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <Box p={3}>
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="body1" color="text.secondary">
            {t("no_insights_available")}
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box p={4}>
      <Grid container spacing={2}>
        {hasAlerts && <AlertsTable alerts={alerts} />}
        <InsightsSection goodInsights={goodInsights} badInsights={badInsights} />
      </Grid>
    </Box>
  );
};

export const Route = createFileRoute("/$organizationId/properties/$substationId/insights")({
  component: InsightsPage,
});
